<template>
  <v-sheet class="foreground" height="100%">

    <!-- MAIN -->
    <v-card class="ma-8">

      <div>

        <table class="final-table th-no-padding lines-b pointer hover full-width">
          <colgroup ref="colgroup1">
            <col width="15px">
            <col width="15px">
            <col width="40px">
            <col width="10px">
            <col width="10px">
            <col width="10px">
          </colgroup>

          <tr class="unselectable">
            <c-table-header
            title="Root ID"
            code="id"
            class="sticky"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Batch No."
            code="batch_number"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Name"
            code="name"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Remaining"
            code="quantity"
            :filters="filters">
            </c-table-header>

            <c-table-header
            title="Source"
            code="source"
            :filters="filters">
            </c-table-header>

            <c-table-header
            title="Match"
            code="match"
            :filters="filters">
            </c-table-header>
      
          </tr>

          <tr class="disable-hover">
            <td>
              <v-text-field
              v-model="filters.search.id"
              placeholder="Search..."
              hide-details
              class="crx-box-input"
              clearable
              color="color1"
              solo
              @keydown.down.prevent="focusNextTableRow()"
              @keydown.up.prevent="focusPreviousTableRow()"
              @keydown.enter.prevent="onEnterKeyTableRow()">
              </v-text-field>
            </td>
            <td>
              <v-text-field
              v-model="filters.search.batch_number"
              placeholder="Search..."
              hide-details
              class="crx-box-input"
              clearable
              color="color1"
              solo></v-text-field>
            </td>
            <td>
              <v-text-field
              v-model="filters.search.name"
              placeholder="Search..."
              hide-details
              class="crx-box-input"
              clearable
              color="color1"
              solo></v-text-field>
            </td>
            <td></td>
            <td></td>
          </tr>

          <row
          v-for="(item, i) in items" 
          :key="item.id"
          :item="item"
          :searchFilters="filters.search"
          :active="currentIndex === i"
          :currentSelection="item.id === currentSelectedID"
          @click.native="clickRow(item)"
          ></row>

        </table>

        <div 
        v-if="items.length === 0"
        key="a"
        class="pa-4">
          No results found

          <v-card>
            <v-img src="https://cdn.pixabay.com/photo/2017/04/08/22/26/meditation-2214532_1280.jpg">

            </v-img>
          </v-card>
        </div>

        <!-- PAGINATION -->
        <c-pagination
        :page="page"
        :pagination="pagination"
        :filters="filters"
        @updatePageNumber="updatePageNumber"
        @goToFirstPage="goToFirstPage"
        @goToPreviousPage="goToPreviousPage"
        @goToNextPage="goToNextPage"
        @goToLastPage="goToLastPage"
        ></c-pagination>
        <!-- PAGINATION -->

      </div>

    </v-card>

  </v-sheet>
</template>

<script>
import Row from './row'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListRouteBindings'
import ServerListKeyboardBindings from '@/mixins/ServerListKeyboardBindings'
import CTableHeader from '@/components/list-server/th'

export default {
  components: {
    Row,
    CTableHeader
  },
  mixins: [ServerListController, ServerListBindings, ServerListKeyboardBindings],
  props: ['url', 'urlArgs'],
  data () {
    return {
      filters: {
        rowsPerPage: 10,
        sortCol: 'id',
        sortAscending: false,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          batch_number: '',
          name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      },
      page: 0
    }
  },
  computed: {
  },
  methods: {
    init (query) {
      this.filters.search.name = query
    },
    clickRow (item) {
      this.$root.$timelineNav.open(item.id)
      /* if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$router.push('/inventory/inventory-definition/view/' + item.id)
      } */
    },
    onOpenDrawer () {
      this.$nextTick(() => {
        try {
          this.currentIndex = 0
          // this.filters.search.name = ''
          this.$refs.searchField.focus()
        } catch (error) {
          console.log(error)
        }
        this.loadAPI()
      })
      /* else {
        try {
          this.$refs.searchField.blur()
        } catch (error) {
          console.log(error)
        }
      } */
    },
    debounceLoad: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/inventory-archive?filters=${encodedFilters}&page=${this.page}`)
          .then(response => {
            var hrend = response.data.execution_time
            // console.log(hrend)
            // console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
            this.items = rows
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
    loadAPI () {
      return this.debounceLoad()
    }
  },
  created () {
    this.loadAPI()
  }
}
</script>